(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["pixelSwiper"] = factory();
	else
		root["pixelSwiper"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 90);
/******/ })
/************************************************************************/
/******/ ({

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


onmessage = function onmessage(e) {
  var rgbaData = calcRgbaData(e.data);
  var pixelData = calcPixelData(e.data, rgbaData);
  postMessage(pixelData);
};

function avg(arr) {
  if (!arr || !arr.length) return 0;
  return arr.reduce(function (a, b) {
    return a + b;
  }) / arr.length;
}

function calcRgbaData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var imageData = data.imageData;
  var width = data.width;
  var res = [];
  for (var i = 0; i < imageData.length; i += 4) {
    if (i / 4 % width === 0) {
      res.push([]);
    }
    res[res.length - 1].push([imageData[i], imageData[i + 1], imageData[i + 2], imageData[i + 3]]);
  }
  return res;
}

function calcPixelData(data, rgbaData) {
  var res = [];
  var size = data.size;
  var colNum = Math.ceil(data.width / size);
  var rowNum = Math.ceil(data.height / size);

  for (var i = 0; i < rowNum; i++) {
    res.push([]);
    for (var j = 0; j < colNum; j++) {
      var startCol = size * i;
      var startRow = size * j;
      var squareData = [];
      for (var m = startCol; m < startCol + size; m++) {
        for (var n = startRow; n < startRow + size; n++) {
          if (rgbaData[m] && rgbaData[m][n]) {
            squareData.push(rgbaData[m][n]);
          } else {
            squareData.push([0, 0, 0, 0]);
          }
        }
      }

      squareData = squareData.filter(function (d) {
        return d[3];
      });
      var avgR = avg(squareData.map(function (d) {
        return d[0];
      }));
      var avgG = avg(squareData.map(function (d) {
        return d[1];
      }));
      var avgB = avg(squareData.map(function (d) {
        return d[2];
      }));
      var avgA = avg(squareData.map(function (d) {
        return d[3];
      }));
      res[i].push({
        r: Math.round(avgR),
        g: Math.round(avgG),
        b: Math.round(avgB),
        a: Math.round(avgA)
      });
    }
  }
  return res;
}

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// pixelSwiper.worker.js